// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"c12674a3","234":"c472d896","404":"0993b62a","505":"6034b43c","768":"d4fe825b","837":"0da2e3bb","848":"2544143f","965":"e638105d"}[chunkId] + ".chunk.css";
};